import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import LoginForm from '@/components/auth/LoginForm';
import SignUpForm from '@/components/auth/SignUpForm';
import GoogleAuthButton from '@/components/auth/GoogleAuthButton';

export default function DirectLogin() {
  const [searchParams] = useSearchParams();
  const defaultTab = searchParams.get('tab') === 'signup' ? 'signup' : 'login';
  const [activeTab, setActiveTab] = useState(defaultTab);
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-vibebops-background">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold">Vibebops</h1>
          <p className="text-vibebops-textMuted mt-2">Connect with creators and showcase your work</p>
        </div>
        
        <Card>
          <Tabs defaultValue={activeTab} onValueChange={setActiveTab} className="w-full">
            <CardHeader>
              <TabsList className="grid w-full grid-cols-2">
                <TabsTrigger value="login">Login</TabsTrigger>
                <TabsTrigger value="signup">Sign Up</TabsTrigger>
              </TabsList>
            </CardHeader>
            
            <CardContent>
              <TabsContent value="login">
                <LoginForm showPassword={showPassword} setShowPassword={setShowPassword} />
              </TabsContent>
              
              <TabsContent value="signup">
                <SignUpForm showPassword={showPassword} setShowPassword={setShowPassword} />
              </TabsContent>
            </CardContent>
          
            <CardFooter className="flex flex-col space-y-4">
              <div className="relative w-full">
                <div className="absolute inset-0 flex items-center">
                  <div className="w-full border-t border-vibebops-border"></div>
                </div>
                <div className="relative flex justify-center text-xs">
                  <span className="bg-vibebops-card px-2 text-vibebops-textMuted">Or continue with</span>
                </div>
              </div>
              
              <div className="w-full">
                <GoogleAuthButton />
              </div>
            </CardFooter>
          </Tabs>
        </Card>
      </div>
    </div>
  );
} 